import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/georgetown")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Georgetown, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Georgetown & Williamson County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Georgetown, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Georgetown and Williamson County.",
      keywords: "awnings Georgetown, awning company Georgetown, custom awnings Georgetown, sail shades Georgetown, patio covers Georgetown, pergola covers Georgetown, metal awnings Georgetown, canvas awnings Georgetown, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Georgetown", "Williamson County"),
  }),
  component: () => <CityHomePage city="Georgetown" region="Williamson County" />,
});
